import api from "./api";

const RESULT_KEY = "yt_oauth_result";

/**
 * Conecta un canal de YouTube por OAuth en una ventana emergente, sin navegar la pestaña
 * principal (así un formulario/wizard a medio rellenar no se pierde). El popup se abre en
 * blanco de forma SÍNCRONA (antes de cualquier await) para que los navegadores no lo bloqueen
 * por no venir de un gesto directo del usuario, y luego se le asigna la URL real de Google.
 *
 * La confirmación llega por localStorage (evento "storage"), no por postMessage a
 * window.opener: las páginas de consentimiento de Google mandan un header
 * Cross-Origin-Opener-Policy que desconecta esa referencia en cuanto el popup pasa por
 * accounts.google.com — ver backend/server.py::_yt_oauth_popup_response, que escribe el
 * resultado ahí antes de cerrarse.
 *
 * Devuelve una Promise que resuelve con {ok, channel_title} o rechaza con un Error si el
 * usuario cierra el popup sin completar, si el navegador lo bloquea, o si algo falla.
 */
export function connectYoutubePopup(channelId) {
  return new Promise((resolve, reject) => {
    const popup = window.open("", "youtube-oauth", "width=520,height=680");
    if (!popup) { reject(new Error("popup_blocked")); return; }
    try { localStorage.removeItem(RESULT_KEY); } catch (e) {}

    let settled = false;
    const finish = (fn, arg) => {
      if (settled) return;
      settled = true;
      window.removeEventListener("storage", onStorage);
      clearInterval(closedCheck);
      fn(arg);
    };
    const onStorage = (event) => {
      if (event.key !== RESULT_KEY || !event.newValue) return;
      let data;
      try { data = JSON.parse(event.newValue); } catch (e) { return; }
      try { localStorage.removeItem(RESULT_KEY); } catch (e) {}
      if (data.ok) finish(resolve, data);
      else finish(reject, new Error(data.error || "oauth_failed"));
    };
    window.addEventListener("storage", onStorage);

    // Red de seguridad si el usuario cierra el popup a mano sin llegar a conectar -- el evento
    // "storage" (casi instantáneo) siempre debería ganarle a este sondeo de 500ms cuando SÍ hay
    // resultado, así que esto solo dispara en el caso de cierre manual real.
    const closedCheck = setInterval(() => {
      if (popup.closed) finish(reject, new Error("popup_closed"));
    }, 500);

    api.get("/youtube/oauth/start", { params: { channel_id: channelId } })
      .then(({ data }) => {
        if (popup.closed) { finish(reject, new Error("popup_closed")); return; }
        popup.location.href = data.auth_url;
      })
      .catch((e) => { try { popup.close(); } catch (_) {} finish(reject, e); });
  });
}
